import {
    SET_FILTER_PAYMENT_BEGIN,
    SET_FILTER_PAYMENT_SUCCESS
} from '../constants'
import {ACTION_STATE} from '../../../common/Utilities'

export function reducer(state, action) {
    switch (action.type) {
        case SET_FILTER_PAYMENT_BEGIN:
            return {
                ...state,
                filterPaymentsState: ACTION_STATE.PENDING,
            }
        case SET_FILTER_PAYMENT_SUCCESS:
            return {
                ...state,
                filterPaymentsState: ACTION_STATE.SUCCESS,
                filterPaymentsData: action.data.filterPaymentsData
            }
        default:
            return state
    }
}
